export default {
  index: [
    {
      path: '/egroup',
      component: resolve => require(['./egruopIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/egroup/_router.js